import * as Sentry from '@sentry/react';

/**
 * Report an error to our error tracking service (Sentry).
 * This thin wrapper makes error reporting testable.
 */
export function reportError(error: unknown, context?: Record<string, unknown>) {
  Sentry.captureException(error, context ? { extra: context } : undefined);
}

/**
 * Report a caught React error (from ErrorBoundary).
 */
export function reportCaughtError(error: unknown, errorInfo: React.ErrorInfo) {
  reportError(error, {
    type: 'caught',
    componentStack: errorInfo.componentStack,
  });
}

/**
 * Report an uncaught React error.
 */
export function reportUncaughtError(error: unknown, errorInfo: React.ErrorInfo) {
  reportError(error, {
    type: 'uncaught',
    componentStack: errorInfo.componentStack,
  });
}

/**
 * Report a recoverable React error (hydration mismatch, etc).
 */
export function reportRecoverableError(error: unknown, errorInfo: React.ErrorInfo) {
  reportError(error, {
    type: 'recoverable',
    componentStack: errorInfo.componentStack,
  });
}
